import React, { useCallback } from 'react';
import { ButtonItem } from '@atlaskit/menu';
import { useIntl } from '@atlassian/jira-intl';
import { setReturnToProjectUrl } from '@atlassian/jira-navigation-apps-sidebar-project-utils';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { useRouterActions } from '@atlassian/react-resource-router';
import { useBacklogSelector } from '../../../../state';
import { getProjectKey, getRapidViewId } from '../../../../state/selectors/app';
import messages from './messages';

export const getManageCustomFiltersUrl = (boardUrl: string): string => `${boardUrl}/custom-filters`;

export type Props = {
	isDisabled: boolean;
};

export const ManageCustomFiltersItem = ({ isDisabled }: Props) => {
	const boardId = useBacklogSelector(getRapidViewId);
	const projectKey = useBacklogSelector(getProjectKey);
	const { formatMessage } = useIntl();
	const { push } = useRouterActions();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const url = `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;

	const onClick = useCallback(() => {
		const analyticsEvent = createAnalyticsEvent({
			action: 'clicked',
			actionSubject: 'dropdownItem',
		});

		setReturnToProjectUrl();
		fireUIAnalytics(analyticsEvent, 'clickManageCustomFilterItem');
		push(url);
	}, [push, url, createAnalyticsEvent]);

	return (
		<ButtonItem isDisabled={isDisabled} onClick={onClick}>
			{formatMessage(messages.displayText)}
		</ButtonItem>
	);
};

export default ManageCustomFiltersItem;
